import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatProgressBar} from '@angular/material/progress-bar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {toast} from 'ngx-sonner';
import {DOWNLOAD_HISTORY_STATUS, DownloadHistoryUpdatedPayload} from '@services/download-history/download-history.models';
import {UUIDType} from '@shared/models';

export interface DownloadRequest extends Pick<DownloadHistoryUpdatedPayload, 'filename' | 'statusAlias' | 'progress' | 'downloadUrl'> {
  id: UUIDType;
}

@Component({
  selector: 'oct-progress-notification',
  imports: [MatProgressSpinnerModule, MatIcon, MatProgressBar, MatTooltipModule, MatIconButton],
  templateUrl: './progress-notification.component.html',
  styleUrl: './progress-notification.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgressNotificationComponent {
  readonly requests = input<DownloadRequest>();
  readonly isComplete = computed(() => this.requests()?.statusAlias?.toLowerCase() === DOWNLOAD_HISTORY_STATUS.COMPLETED.toLowerCase());

  close() {
    toast.dismiss(this.requests().id);
  }

  downloadFile() {
    if (this.requests()?.downloadUrl) {
      window.open(this.requests().downloadUrl, '_blank');
    }
  }
}
